var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["emp.col.entrance.entranceName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                disabled:
                                  this.$store.getters.applicationCode !=
                                  "emp_platform",
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["emp.col.entrance.entranceName"],
                                allowClear: ""
                              },
                              on: { change: _vm.entranceChange },
                              model: {
                                value: _vm.model.entranceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "entranceId", $$v)
                                },
                                expression: "model.entranceId"
                              }
                            },
                            _vm._l(_vm.entrancelist, function(item, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index.toString(),
                                  attrs: { value: item.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.entranceName) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.colCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.language["trmorder.auto"],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.colCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colCode", $$v)
                              },
                              expression: "model.colCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.colName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.col.colName"]
                            },
                            model: {
                              value: _vm.model.colName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colName", $$v)
                              },
                              expression: "model.colName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: {
                                type: "primary",
                                disabled: _vm.formDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "emp_col_tbl",
                                    "col_name",
                                    _vm.colNameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["ad.image"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource
                            },
                            model: {
                              value: _vm.model.colImg,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colImg", $$v)
                              },
                              expression: "model.colImg"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.templateTypeName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "templateType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["emp.col.colName"],
                              type: "list",
                              dictCode: "emp_col_template_type",
                              disabled: !!_vm.model.id
                            },
                            model: {
                              value: _vm.model.templateType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "templateType", $$v)
                              },
                              expression: "model.templateType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.publishStatusName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishStatus"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "hhemp_publish_status",
                              readOnly: true,
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.publishStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publishStatus", $$v)
                              },
                              expression: "model.publishStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.colVisible == true,
                              expression: "colVisible==true"
                            }
                          ],
                          attrs: {
                            label: _vm.language["emp.col.publisher"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publisher"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "",
                              readOnly: true,
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.publisher,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publisher", $$v)
                              },
                              expression: "model.publisher"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.colVisible == true,
                              expression: "colVisible==true"
                            }
                          ],
                          attrs: {
                            label: _vm.language["emp.col.publishTime"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishTime"
                          }
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "",
                              readOnly: true,
                              "date-format": "YYYY-MM-DD HH:mm:ss"
                            },
                            model: {
                              value: _vm.model.publishTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publishTime", $$v)
                              },
                              expression: "model.publishTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.colVisible == true,
                              expression: "colVisible==true"
                            }
                          ],
                          attrs: {
                            label: _vm.language["emp.col.contentNumber"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "detailNumber"
                          }
                        },
                        [
                          _vm.model.childNumber > 0
                            ? _c("a-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "",
                                  readOnly: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.childNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "childNumber", $$v)
                                  },
                                  expression: "model.childNumber"
                                }
                              })
                            : _c("a-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "",
                                  readOnly: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.contentNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "contentNumber", $$v)
                                  },
                                  expression: "model.contentNumber"
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.sortNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 1,
                              max: 9999,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.col.sortNo"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.remark"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.col.remark"]
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: {
                                type: "primary",
                                disabled: _vm.formDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "emp_col_tbl",
                                    "remark",
                                    _vm.remarkLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("language-model", {
                ref: "languageModel",
                on: { ok: _vm.languageOk }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }